
/**
 * @description 询问提示框
 * @param {Object} that
 * @param {Object} msg
 * @param {Object} callback
 */
window.confirm = function (that, msg, callback) { //  判断是否确认删除
  that.$confirm(msg, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    callback(true);
  }).catch(() => {
    that.$message({
      type: 'info',
      message: '已取消'
    });
  });
}

/**
 * @description 删除确认弹出框
 * @param {Object} that
 * @param {Object} msg
 * @param {Object} callback
 */
window.confirmDelete = function (that, msg, callback) {
  if (msg == null || typeof (msg) == "undefined" || msg == "") {
    msg = "您确定要删除选中的信息吗？ 删除后信息将不可恢复，请知悉";
  }
  confirm(that, msg, callback);
}

/**
 * @description 以警告的样式显示提示语
 * @param {Object} that
 * @param {Object} msg
 */
window.warning = function (that, msg) {
  that.$message({
    message: msg,
    type: "warning"
  });
}

/**
 * @description 以成功的样式提示语
 * @param {Object} that
 * @param {Object} msg
 */
window.success = function (that, msg) {
  that.$message({
    message: msg,
    type: "success"
  });
}

/**
 * @description 以普通的样式提示语
 * @param {Object} that
 * @param {Object} msg
 */
window.info = function (that, msg) {
  that.$message({
    message: msg,
    type: "info"
  });
}


/**
 * @description 以错误的样式显示提示语
 * @param {Object} that
 * @param {Object} msg
 */
window.error = function (that, msg) {
  that.$message({
    message: msg,
    type: "error"
  });
}
